import React, { useContext } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { TextField } from '@mui/material'
import 'json-diff-kit/dist/viewer.css';
import AppContext from '../../state/AppContext';
import { useSelector } from 'react-redux';
import { updateIAConfig } from './edit-collections-actions';

const EditCollectionIA = (props) => {

    const state = useSelector(state => state.pages.editCollection)
    const iaConfig = state.iaConfig

    return (
        <>
            <form>
                <div className="grid gap-8">
                    <p className="text-md border-b pb-4 text-gray-800 p-4 bg-gray-200">In this section you can configure how the AI ​​should analyze this collection, indicating a description of its use, the important elements it should pay attention to, and also those elements that are not relevant or should be ignored.</p>
                    <div className="grid grid-cols-1 gap-4 p-4"  >
                        <TextField 
                            label="Description" 
                            multiline 
                            rows={4} 
                            fullWidth
                            name="description"
                            helperText="Describe the purpose of the collection and the elements it contains." 
                            value={iaConfig.description}
                            onChange={updateIAConfig}
                        />
                        <TextField 
                            label="Important Elements" 
                            multiline 
                            rows={4} 
                            fullWidth 
                            name="importantStatements"
                            helperText="Indicate the elements that are important to the collection and should be analyzed in detail." 
                            value={iaConfig.importantStatements}
                            onChange={updateIAConfig}
                        />
                        <TextField 
                            label="Ignored Elements" 
                            multiline 
                            rows={4} 
                            fullWidth 
                            name="ignoreStatements"
                            helperText="Indicate the elements that are not relevant to the collection and should be ignored." 
                            value={iaConfig.ignoreStatements}
                            onChange={updateIAConfig}
                        />
                    </div>
                </div>
            </form>
        </>
    )
}

export default EditCollectionIA